import { OrtecTimeslotClient } from './OrtecTimeslotClient';
import { PreferredTimeSlotClient } from './PreferredTimeslotClient';

export const AppointmentClient = {
  ...OrtecTimeslotClient,
  ...PreferredTimeSlotClient
};
